import { POST, FormMultiPart } from '@/apis/base/httpclient'
import { MSConstant } from '@/commons/wildcards'
import FileApi from '@/apis/other/fileAPI'

export function checkIsUploadAnonymous (storageFileType) {
  const storageFileTypes = MSConstant.StorageFileType
  const anonymousKeys = Object.keys(storageFileTypes).filter(key => key.startsWith('Anonymous_'))
  const isAnonymousType = anonymousKeys.some(key => storageFileTypes[key] === storageFileType)

  return isAnonymousType
}

function getConfigApiUpload (config) {
  const apiPath = checkIsUploadAnonymous(config.StorageType) ? '/anonymous/multi' : '/multi'
  const urlUpload = FileApi.getAPIUrl() + apiPath
  const configs = {
    url: urlUpload,
    method: POST,
    data: getFormData(config),
    headers: {
      'Content-Type': FormMultiPart,
    },
  }

  return configs
}

/**
     * Lấy thông tin file ra
     * Mặc định là có thông tin file rồi nên ko cần check nữa
     */
function getFormData (config) {
  const form = new FormData()
  form.append('type', config.StorageType)
  form.append('ownerID', config.OwnerId)
  config.Files.forEach(file => {
    form.append(file.name, file)
  })

  return form
}

export default getConfigApiUpload
export { getFormData }
